import { useSupportContent } from '../../content/sections/support.js';

export function TypingIndicator({ senders }: { readonly senders: readonly string[] }) {
  const copy = useSupportContent();
  if (senders.length === 0) return null;
  return (
    <div className="px-4 py-1 text-xs text-muted-foreground" aria-live="polite">
      {senders.length === 1
        ? copy.typingIndicator.singular
        : copy.typingIndicator.plural(senders.length)}
    </div>
  );
}
